/* Allinea la tendina compatta sotto la voce padre del menu header (vedi torineser-dropdown.css)
   e calcola l'altezza del "ponte" invisibile tra voce e tendina, senza coprire la voce stessa. */
(() => {
  const PANEL_PADDING = 18;

  const place = (li) => {
    if (!li || li.getAttribute('slot') === 'overflow') return;
    const sub = li.querySelector(':scope > .menu-list__submenu');
    const title = li.querySelector('.menu-list__link-title');
    const link = li.querySelector('.menu-list__link');
    if (!sub || !title || !link) return;
    const cb = sub.offsetParent;
    if (!cb) return;
    const pad = parseFloat(getComputedStyle(title).paddingInlineStart) || 0;
    const left = title.getBoundingClientRect().left + pad - cb.getBoundingClientRect().left - cb.clientLeft - PANEL_PADDING;
    sub.style.setProperty('--tt-submenu-left', `${Math.max(0, Math.round(left))}px`);
    const gap = sub.getBoundingClientRect().top - link.getBoundingClientRect().bottom;
    sub.style.setProperty('--tt-submenu-bridge', `${Math.max(0, Math.floor(gap))}px`);
  };

  const handler = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const li = target.closest('#header-component .menu-list__list-item');
    if (li) place(li);
  };

  document.addEventListener('pointerover', handler, { passive: true });
  document.addEventListener('focusin', handler);
})();
